import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addCategoryPost } from "../repositories/storeRep";




const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const addCategoryData= createAsyncThunk(
  "addCategory",
  async (data, thunkAPI) => {
    const response = await addCategoryPost(data);
    return response;
  }
);
export const addCategorySlice = createSlice({
  name: "addCategory",
  initialState,
  extraReducers: {
    [addCategoryData.pending]: (state) => {
      state.loading = true;
    },
    [addCategoryData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [addCategoryData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default addCategorySlice.reducer;
